/**
 * @generated SignedSource<<5ba45758c18e2f7859332da2ba2a5e37>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type WidgetTableCellChangeType = "negative" | "neutral" | "positive";
import { FragmentRefs } from "relay-runtime";
export type WidgetTable_cell$data = {
  readonly changeType: WidgetTableCellChangeType | null;
  readonly value: string | null;
  readonly " $fragmentType": "WidgetTable_cell";
};
export type WidgetTable_cell$key = {
  readonly " $data"?: WidgetTable_cell$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetTable_cell">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetTable_cell",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "value",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "changeType",
      "storageKey": null
    }
  ],
  "type": "WidgetTableCell",
  "abstractKey": null
};

(node as any).hash = "6efcb681869918f5674e753649cd8360";

export default node;
